import { paramKey, paramValue } from "../constants/parameterNames";
import { getParamValue } from "../helpers/parameter.accessors";
import details from './UseOption.details.md';

const description = 'Allows setting FormsViewer options that affect form behavior.';

const requiredParameters = {
    [paramKey]: {
        description: 'The key (identifier) for the option',
    },
    [paramValue]: {
        description: 'The value to set to the option',
    },
};

const execute = ({ settings, parameters }) => {
    const key = getParamValue(parameters, paramKey);
    const value = getParamValue(parameters, paramValue);

    const prevValue = settings.getOption(key);

    settings.setOption(key, value);

    return `${prevValue || ''} -> ${value}`;
};

const UseOption = {
    description,
    details,
    requiredParameters,
    execute,
};

export default UseOption;